import { SET_BUS_TICKET } from "../actions/ticket";



export default function setBusTicket(state = [], action = {}) {
    switch (action.type) {
        case SET_BUS_TICKET:
            const { BusTicket } = action;

            return {
                ...state,
                BusTicket: BusTicket,
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/BusticketReduser.js